import type { EnnismoreTheme } from '@/ui/theme';

import { delanoTheme } from './delano.theme';

export const delanoMiamiTheme: EnnismoreTheme = {
  ...delanoTheme,
  logoUrl: '/brands/delano/images/delano-miami-beach-logo.svg',
  componentProperties: {
    ...delanoTheme.componentProperties,
    header: {
      ...delanoTheme.componentProperties?.header,
      logo: {
        ...delanoTheme.componentProperties?.header?.logo,
        paddingBlock: '24px',
        paddingInline: '48px 0',
      },
    },
  },
};
